export const FETCH_CERTIFICATE_REQUEST = 'CERTIFICATE/FETCH_CERTIFICATE_REQUEST';
export const FETCH_CERTIFICATE_SUCCESS = 'CERTIFICATE/FETCH_CERTIFICATE_SUCCESS';
export const FETCH_CERTIFICATE_FAILURE = 'CERTIFICATE/FETCH_CERTIFICATE_FAILURE';

export const ADD_CERTIFICATE_REQUEST = 'CERTIFICATE/ADD_CERTIFICATE_REQUEST';
export const ADD_CERTIFICATE_SUCCESS = 'CERTIFICATE/ADD_CERTIFICATE_SUCCESS';
export const ADD_CERTIFICATE_FAILURE = 'CERTIFICATE/ADD_CERTIFICATE_FAILURE';
